import ActionResultType from '../../../interfaces/pieces/ActionResultType';
import BordereauActionType from '../../../interfaces/pieces/bordereaux/BordereauActionType';
import type BordereauxRejetCollectivite from '../../../interfaces/pieces/bordereaux/BordereauxRejetCollectivite';
import type { BaseLiquidationOptions } from '../../../interfaces/pieces/mouvements/liquidation/BaseLiquidationOptions';
import type { BordereauWithState } from '../../../interfaces/pieces/TreeRow';
import type TreeviewActionResult from '../../../interfaces/pieces/TreeviewActionResult';
import BaseLiquidationAction from '../../pieces/BaseLiquidationAction';

class BordereauRejeterCollectiviteAction extends BaseLiquidationAction<
	BordereauWithState,
	BordereauActionType
> {
	constructor(options: BaseLiquidationOptions = null) {
		super(options);
		this.label = 'Rejeter le bordereau à l’initiative de la collectivité';
		this.type = BordereauActionType.REJETER_COLLECTIVITE;
	}

	execute = (
		_bordereau: BordereauWithState,
	): TreeviewActionResult<BordereauWithState> => ({
		type: ActionResultType.MODAL,
		extraProps: {
			isSuperUser: this.isSuperUser,
			bordereauRejeterCollectiviteModal: {
				visible: true,
			},
		},
	});

	/**
	 * Le modal de rejet collectivité injecte un payload spécifique
	 * (ancien + nouveau bordereau), d’où le cast.
	 */
	executeAction = (
		data: BordereauWithState,
	): TreeviewActionResult<BordereauWithState>[] => {
		const { nouveauBordereau, ancienBordereau } =
			data as unknown as BordereauxRejetCollectivite;
		return [
			{
				type: ActionResultType.UPDATE,
				result: Promise.resolve(ancienBordereau),
				shouldRefreshChildren: true,
			},
			{
				type: ActionResultType.ADD,
				result: Promise.resolve(nouveauBordereau),
				shouldRefreshChildren: true,
			},
		];
	};
}

export default BordereauRejeterCollectiviteAction;
